import { lazy } from "react";

import Loadable from "../components/Loadable";
import MainLayout from "../layout/MinimalLayout";

const WatchPage = Loadable(lazy(() => import("../pages/watch/Watch")));

const MainRoutes = {
    path: "/watch/",
    element: <MainLayout />,
    children: [
        {
            path: ":link",
            element: <WatchPage />
        }
    ]
};

export default MainRoutes;